import { render, staticRenderFns } from "./history-quest.vue?vue&type=template&id=28192e05&scoped=true"
import script from "./history-quest.vue?vue&type=script&lang=js"
export * from "./history-quest.vue?vue&type=script&lang=js"
import style0 from "./history-quest.vue?vue&type=style&index=0&id=28192e05&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28192e05",
  null
  
)

export default component.exports